import React from "react";

const ChartWidgetLoading = () => {
    return (
        <div
            style={{ height: "100%" }}
            className="float-e-margins ibox"
        >
            <div
                className={"widget-bottom-corners ibox-content-widget-full-height"}
                style={{
                    backgroundColor: "white",
                    paddingBottom: "10px",
                    height: "calc(100% - 80px)"
                }}
            >
                LOADING
            </div>
        </div>
    );
};

export default ChartWidgetLoading;